export default "__VITE_ASSET__bbb2c00d__"